import dateTimeMask from './dateTimeMask'

const dateTimeZonedMask = `${dateTimeMask} ZZ`

export default dateTimeZonedMask
